<template>
  <button :class="classes" :disabled="disabled" @click="onclick">
    <span class="ms-Button-label"><slot></slot></span>
  </button>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '',
      validator: function(value) {
        return ['', 'primary', 'secondary'].indexOf(value) !== -1;
      }
    },
    size: {
      type: String,
      default: '',
      validator: function(value) {
        return ['', 'small'].indexOf(value) !== -1;
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      const classes = ['ms-Button'];
      if (this.color === 'primary') {
        classes.push('ms-Button--primary');
      }
      if (this.size === 'small') {
        classes.push('ms-Button--small');
      }
      return classes;
    }
  },
  mounted() {
    new fabric['Button'](this.$el, function() {});
  },
  methods: {
    onclick(e) {
      this.$emit('click', e);
    }
  }
};
</script>
